import { Resource } from 'src/app/global/domain/resource.model';

export class ArquivoConciliacaoBancaria extends Resource {
  fileName: string;
  contentType: string;
  content: Blob;
  invalido: boolean;
  dataCadastro: Date;
  processando?: boolean;
}
